import React from 'react';
import classes from './backgroundVideo.module.css';

const BackgroundVideo = () => {
  const backgroundSource = require('../../assets/videos/night_video.mp4');
  return (
    <div className={classes.bgVideoContainer}>
      <video autoPlay="autoplay" loop="loop" muted className={classes.video}>
        <source src={backgroundSource} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className={classes.overlay}></div>
    </div>
  );
};

export default BackgroundVideo;
